import Model from 'ducker-model';

// 1.定义property
const property = {
  names: String,
  icons: String,
  mid: String,
  isINOFFICE: String,
  days: String,
  time: String,
  rate: String,
};

// 2.定义replacedKeyFromPropertyName
const replacedKeyFromPropertyName = {
  names: {
    property: 'MGRNAME',
    defaultValue: [],
    computed: (MGRNAME) => MGRNAME.split(','),
  },
  icons: {
    property: 'NEWPHOTOURL',
    defaultValue: [],
    computed: (NEWPHOTOURL) => NEWPHOTOURL.split(','),
  },
  mid: {
    property: 'MGRID',
    defaultValue: [],
    computed: (MGRID) => MGRID.split(','),
  },
  isINOFFICE: {
    property: 'ISINOFFICE',
    defaultValue: [],
    computed: (ISINOFFICE) => ISINOFFICE.split(','),
  },
  days: {
    property: 'DAYS',
    defaultValue: '--',
    computed: (DAYS) => {
      const daysInt = parseInt(DAYS, 10);
      let str = '(';
      if (daysInt < 365) {
        str += (`${daysInt}天`);
      } else if (daysInt === 365) {
        str += ('1年');
      } else {
        str += (`${parseInt(daysInt / 365.0, 10)}年又${daysInt % 365}天`);
      }
      str += ')';
      return str;
    },
  },
  time: {
    property: ['FEMPDATE', 'LEMPDATE'],
    defaultValue: '--',
    computed: ([FEMPDATE, LEMPDATE]) => {
      let timeStr = `${FEMPDATE}`;
      if (!LEMPDATE || LEMPDATE.length === 0 || LEMPDATE === '--') {
        timeStr += '至今';
      } else {
        timeStr += `~${LEMPDATE}`;
      }
      // timeStr = timeStr.replace(/-/g, '/');
      return timeStr;
    },
  },
  rate: {
    property: 'PENAVGROWTH',
    defaultValue: '--',
    computed: (PENAVGROWTH) => {
      if (PENAVGROWTH) {
        if (PENAVGROWTH === '--') {
          return '--';
        }
        return `${parseFloat(PENAVGROWTH).toFixed(2)}`;
      }
      return '--';
    },
  },
};
export default new Model(property, replacedKeyFromPropertyName);
